/**
 * TanStack Query hooks for `affiliate-signup`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	fetchFormConfig,
	affiliateSignupQueryKeys,
	type AffiliateSignupCreateBody,
	type AffiliateSignupFormConfig,
	type AffiliateSignupRow,
} from "./api";

export function useAffiliateSignupFormConfig(): UseQueryResult<AffiliateSignupFormConfig, Error> {
	return useQuery({
		queryKey: affiliateSignupQueryKeys.formConfig(),
		queryFn: fetchFormConfig,
		retry: false,
		staleTime: 60_000,
	});
}

export function useAffiliateSignupCreate(): UseMutationResult<
	AffiliateSignupRow,
	Error,
	AffiliateSignupCreateBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateSignupQueryKeys.all });
		},
	});
}
